const semanticClassNames = {
  root: 'selectable-container-input',
  input: 'selectable-container-input__custom-input',
  label: 'selectable-container-input__label',
} as const;

export default semanticClassNames;
